<header class="header-wrapper main-header">
  <ng-container [ngTemplateOutlet]="headerTop"></ng-container>

  @if(!isAdmin) {
    <ng-container [ngTemplateOutlet]="headerBottom"></ng-container>
  }
</header>

@if (isCurrentFeeRoute() && !isFeeGroupsSectionRoute()) {
  <div class="fee-mobile-add-dock">
    <div #feeAddSplitBtnMobile class="add-member-btn"
         [class.add-member-btn--menu-open]="isFeeAddMenuOpen"
         [class.add-member-btn--disabled]="isFeeAddActionDisabled">
      <button #feeAddBtnLeftMobile class="add-member-btn__left" type="button"
              [disabled]="isFeeAddActionDisabled"
              (click)="openSelectedFeeAction()">
        <mat-icon class="add-member-btn__plus">add</mat-icon>
        <span class="add-member-btn__label">{{ feeAddButtonLabel | translate }}</span>
      </button>
      <div class="add-member-btn__divider"></div>
      <button
        class="add-member-btn__chevron"
        type="button"
        [disabled]="isFeeAddActionDisabled"
        [matMenuTriggerFor]="isFeeAddActionDisabled ? null : feeAddMenu"
        (menuOpened)="onFeeAddMenuOpened(feeAddBtnLeftMobile)"
        (menuClosed)="isFeeAddMenuOpen = false">
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>
    </div>
  </div>
}

<mat-menu
  #feeAddMenu="matMenu"
  class="fee-add-member-menu"
  [style.--fee-add-menu-width]="feeAddMenuWidthPx ? (feeAddMenuWidthPx + 'px') : null"
  xPosition="before"
  [yPosition]="isCompactFeeActionViewport ? 'above' : 'below'"
  overlapTrigger="false">
  @if (feeAddMenuSelected === 'group') {
    <button
      mat-menu-item
      type="button"
      class="fee-add-member-menu__item"
      (click)="openFeeAddMemberPage()">
      + {{ 'fee.actions.add_member' | translate }}
    </button>
  } @else {
    <button
      mat-menu-item
      type="button"
      class="fee-add-member-menu__item"
      (click)="openFeeCreateGroupPage()">
      + {{ 'fee.actions.add_group' | translate }}
    </button>
  }
</mat-menu>

<ng-template #headerTop>
  <div class="individual__header">
    @if(!isAdmin) {
      @if (isFeeDetailRoute && activeUserIndustry) {
        <div class="fee-header-left">
          <div class="fee-header-icon" [class.fee-header-icon--with-logo]="!!activeFeeLogoUrl">
            <img
              [src]="activeFeeLogoUrl"
              [alt]="activeUserIndustry.companyName"
              class="fee-header-logo"
              (error)="onFeeLogoError()">
          </div>
          <div class="fee-header-path">
            <span class="fee-header-name">{{ activeUserIndustry.companyName || ('fee.title' | translate) }}</span>
            @if (activeUserIndustry.cardId) {
              <span class="fee-header-username"
                    (click)="navigateToIndustryCard(activeUserIndustry!.cardId!)">
                {{ formatCardUsername(activeUserIndustry!.cardId!) }}
              </span>
            }
            @if (feeHeaderGroupName) {
              <span class="fee-header-separator">/</span>
              <span class="fee-header-crumb fee-header-crumb--clickable" (click)="goToFeeHeaderGroup()">{{ feeHeaderGroupName }}</span>
            }
            @if (feeHeaderSubgroupName) {
              <span class="fee-header-separator">/</span>
              <span class="fee-header-crumb fee-header-crumb--clickable" (click)="goToFeeHeaderSubgroup()">{{ feeHeaderSubgroupName }}</span>
            }
          </div>
        </div>
      } @else {
        <div class="header__title mr-10px">
          <span>{{ pageTitle }}</span>
          @if (isCardsCountVisible) {
            <span class="title__slash">&nbsp;/&nbsp;</span>
            <span>{{ cardsCount }}</span>
          }
        </div>
      }
    }

    <div class="header__features"
         [class]="isOnlySearchVisible && !isAdmin ? 'width-70' : ''"
         [ngClass]="{'width-100 d-flex justify-content-end': isAdmin}">
      @if(!isAdmin && !isFeeDetailRoute) {
        @if (!isMenuPageRoute()) {
        <app-search class="search-desktop" [style]="isOnlySearchVisible ? 'width: 100% !important;' : ''"></app-search>
        }

        @if (!isOnlySearchVisible) {
          @if ((isCardsPageRoute() || isTeamsPageRoute() || isHistoryPageRoute()) && !isEditCardsPageRoute() && !isMenuPageRoute()) {
            <ng-container [ngTemplateOutlet]="toggleView"></ng-container>
          }

          @if (isTeamRoute) {
            <button class="header__sort-button" [matMenuTriggerFor]="cardsSortMenu"
                    [ngClass]="{ 'background-change': menuOpen }"
                    (menuOpened)="menuOpen = true"
                    (menuClosed)="menuOpen = false">
              <mat-icon>sort</mat-icon>
              <span>{{ 'individual_card.sort' | translate }}</span>
            </button>
          }

          @if ((isCardsPageRoute() || isHistoryPageRoute()) && !isEditCardsPageRoute()) {
            <button class="filled-button short-button button-md" (click)="openCreateCard()">
              <mat-icon class="mr-10px">add</mat-icon>
              {{ 'home-page-content.create_new_card' | translate }}
            </button>
          }
        }
      }

      @if (isCurrentFeeRoute()) {
        <div #feeAddSplitBtn class="add-member-btn"
             [class.add-member-btn--menu-open]="isFeeAddMenuOpen"
             [class.add-member-btn--disabled]="isFeeAddActionDisabled">
          <button #feeAddBtnLeft class="add-member-btn__left" type="button"
                  [disabled]="isFeeAddActionDisabled"
                  (click)="openSelectedFeeAction()">
            <mat-icon class="add-member-btn__plus">add</mat-icon>
            <span class="add-member-btn__label">{{ feeAddButtonLabel | translate }}</span>
          </button>
          <div class="add-member-btn__divider"></div>
          <button
            class="add-member-btn__chevron"
            type="button"
            [disabled]="isFeeAddActionDisabled"
            [matMenuTriggerFor]="isFeeAddActionDisabled ? null : feeAddMenu"
            (menuOpened)="onFeeAddMenuOpened(feeAddBtnLeft)"
            (menuClosed)="isFeeAddMenuOpen = false">
            <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
        </div>
      }

      <div class="user-info-wrapper-desktop" >
        <div class="user-info-wrapper header-links">
          <a class="user-info" [matMenuTriggerFor]="userInfo" [matMenuTriggerRestoreFocus]="false">
            <img
              [src]="isAdmin ? 'assets/svg/scanMeLogoSingle.svg' : (profileImageUrl ? profileImageUrl : 'assets/svg/defaultUserIcon.svg')"
              [ngClass]="{'img-admin': isAdmin}"
              class="img-style"
              alt="">
          </a>
        </div>
      </div>

      @if (!isAdmin) {
        <div class="lang-name">
          <span id="language" [matMenuTriggerFor]="languageChange">{{ lang | uppercase }}</span>
          <mat-menu #languageChange="matMenu" xPosition="before" yPosition="below">
            <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.HY)">
              {{ Language.HY | uppercase }}
            </p>
            <hr class="lang-mat-menu-hr">
            <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.EN)">
              {{ Language.EN | uppercase }}
            </p>
            <hr class="lang-mat-menu-hr">
            <p class="cursor-pointer text-center m-0" (click)="changeLang(Language.RU)">
              {{ Language.RU | uppercase }}
            </p>
          </mat-menu>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #headerBottom>
  <header class="mb__individual__header">
    <div class="mb__individual__header__top">
      @if (currentRoute){
        <div class="back-div mt-1 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center">
          <mat-icon (click)="returnToPreviousPage()" class="cursor-pointer">keyboard_arrow_left</mat-icon>
          <span (click)="returnToPreviousPage()" class="cursor-pointer">
              {{ 'header_back' | translate }} </span>
        </div>
      } @else {
        <img routerLink="/home"  src="assets/svg/logo-mb.svg" alt="logo">
      }
      <div>
        <div class="user-info-wrapper-desktop">
          <div class="user-info-wrapper header-links">
            <a class="user-info" [matMenuTriggerFor]="userInfo" [matMenuTriggerRestoreFocus]="false">
              <img
                [src]="isAdmin ? 'assets/svg/scanMeLogoSingle.svg' : (profileImageUrl ? profileImageUrl : 'assets/svg/defaultUserIcon.svg')"
                [ngClass]="{'img-admin': isAdmin}"
                class="img-style"
                alt="">
            </a>
          </div>
        </div>

        <img (click)="openSidebar()" class="hamburger-icon" src="/assets/svg/open-viewed-cards-hamburger-icon.svg" alt="">
      </div>
    </div>
    <div class="mb__individual__header__bottom">
      @if (isTeamRoute) {
        <ng-container [ngTemplateOutlet]="teamMobileHeader"></ng-container>
      } @else if (isHistoryRoute) {
        <ng-container [ngTemplateOutlet]="viewedCardsMobileHeader"></ng-container>
      } @else if (isPlanSubscriptionPage) {
        <ng-container [ngTemplateOutlet]="planSubscriptionsMobileHeader"></ng-container>
      } @else {
        <ng-container [ngTemplateOutlet]="individualMobileHeader"></ng-container>
      }
    </div>
  </header>
</ng-template>

<ng-template #individualMobileHeader>
  @if(!isSearchOpened) {
    <button class="mobile-search-button" (click)="isSearchOpened = true">
      <img src="assets/svg/search-samll.svg">
    </button>
    @if (isCardsPageRoute() && !isEditCardsPageRoute() && !isMenuPageRoute()) {
      <ng-container [ngTemplateOutlet]="toggleView"></ng-container>
    }
  } @else {
    <app-search></app-search>
    <button class="text-button short-button" (click)="isSearchOpened = false">{{ 'Cancel' | translate }}</button>
  }
</ng-template>

<ng-template #teamMobileHeader>
  @if(!isSearchOpened) {
    <button class="mobile-search-button" (click)="isSearchOpened = true">
      <img src="assets/svg/search-samll.svg">
    </button>
    <div class="mb__individual__header__bottom_actions">
      <ng-container [ngTemplateOutlet]="toggleView"></ng-container>
      <button class="header__sort-button" [matMenuTriggerFor]="cardsSortMenu"
              [ngClass]="{ 'background-change': menuOpen }"
              (menuOpened)="menuOpen = true"
              (menuClosed)="menuOpen = false">
        <mat-icon>sort</mat-icon>
        <span>{{ 'individual_card.sort' | translate }}</span>
      </button>
    </div>
  } @else {
    <app-search></app-search>
    <button class="text-button short-button" (click)="isSearchOpened = false">{{ 'Cancel' | translate }}</button>
  }
</ng-template>

<ng-template #viewedCardsMobileHeader>
  @if(!isSearchOpened) {
    <button class="mobile-search-button" (click)="isSearchOpened = true">
      <img src="assets/svg/search-samll.svg">
    </button>
    <div class="mb__individual__header__bottom_actions">
      <ng-container [ngTemplateOutlet]="toggleView"></ng-container>
      @if (isClearHistoryButtonActive) {
        <button class="clear-history-button" (click)="clearHistory($event)">{{ 'delete' | translate }}</button>
      }
    </div>
  } @else {
    <app-search></app-search>
    <button class="text-button short-button" (click)="isSearchOpened = false">{{ 'Cancel' | translate }}</button>
  }
</ng-template>

<ng-template #planSubscriptionsMobileHeader>
  @if(!isSearchOpened) {
    <button class="mobile-search-button" (click)="isSearchOpened = true">
      <img src="assets/svg/search-samll.svg">
    </button>
    <div class="toggle-container">
      <button class="toggle-button" [class.active]="isMyPlanActive" (click)="togglePlan(true)">
        <span style="display: block !important; white-space: nowrap;">{{ 'My_Plan' | translate }}</span>
      </button>
      <button class="toggle-button" [class.active]="!isMyPlanActive" (click)="togglePlan(false)">
        <span style="display: block !important; white-space: nowrap;">{{ 'All_Subscriptions' | translate }}</span>
      </button>
    </div>
  } @else {
    <app-search></app-search>
    <button class="text-button short-button" (click)="isSearchOpened = false">{{ 'Cancel' | translate }}</button>
  }
</ng-template>

<mat-menu #userInfo class="user-info-mat-menu">
  <div class="user-info-top" (click)="$event.stopPropagation()">
    @if (!isAdmin) {
      <mat-icon class="user-info-edit-icon" (click)="showProfileEdit(); userInfo.closed.emit(); $event.stopPropagation();">
        edit_outline
      </mat-icon>
    }
    <ul class="user-info-column">
      <li>
        <mat-icon class="mr-14px user-info-def-icon">person_outline</mat-icon>
        {{ name }} {{ isAdmin ? 'ADMIN' : surname }}
      </li>
      @if (!isAdmin) {
        <li>
          <mat-icon class="mr-14px user-info-def-icon">mail_outline</mat-icon>
        {{ email ? email : ('common.unknown' | translate) }}
        </li>
        <li>
          <mat-icon class="mr-14px user-info-def-icon">phone_enabled_outline</mat-icon>
        {{ phone ? phone : ('common.unknown' | translate) }}
        </li>
      }
    </ul>
  </div>
  <hr class="user-info-hr" (click)="$event.stopPropagation()">
  <div class="user-info-bottom" (click)="isAdmin ? logoutAdmin() :  logout(); userInfo.closed.emit()">
          <span>{{ 'home-page-content.sign_out' | translate }}</span>
    <mat-icon class="user-info-logout-icon">logout</mat-icon>
  </div>
</mat-menu>

<mat-menu #cardsSortMenu>
  <app-cards-sort-dialog></app-cards-sort-dialog>
</mat-menu>

<ng-template #toggleView>
  @if (!isActivityPageRoute() && !isEditCardsPageRoute()) {
    <div class="toggle-container">
      <button class="toggle-button" [class.active]="isListView" (click)="toggleViewList(true)">
        <img class="mr-10px" src="/assets/viewed-favorites/list.svg">
        <span>{{ 'individual_card.list' | translate }}</span>
      </button>
      <button class="toggle-button" [class.active]="!isListView" (click)="toggleViewList(false)">
        <img class="mr-10px"
             [src]="isListView ? '/assets/viewed-favorites/grid.svg' : '/assets/viewed-favorites/grid-active.svg'">
        <span>{{ 'individual_card.grid' | translate }}</span>
      </button>
    </div>
  } @else {
      <div class="toggle-container">
        <button class="toggle-button" [class.active]="isActivityPage === ActivityTabs.ALL_INDIVIDUAL"
                (click)="toggleIndividual(ActivityTabs.ALL_INDIVIDUAL)">
          <img src="assets/svg/person_16.svg" alt="">
          <span class="mx-2">{{ 'activity.all_individuals' | translate }}</span>
        </button>
        @if (currentTeam) {
          <button class="toggle-button" [class.active]="isActivityPage === ActivityTabs.MY_TEAM"
                  (click)="toggleIndividual(ActivityTabs.MY_TEAM)">
            <img src="assets/svg/shield_person.svg" alt="">
            <span class="mx-2">{{ 'my_team.my_team' | translate }}</span>
          </button>
        }
        @if (teams.length) {
          <button class="toggle-button" [matMenuTriggerFor]="menu"
                  [class.active]="isActivityPage === ActivityTabs.ALL_TEAMS"
                  (click)="toggleIndividual(ActivityTabs.ALL_TEAMS)">
            <img src="assets/svg/group.svg" alt="">
            <span class="mx-2">{{ 'activity.all_teams' | translate }}</span>
            @if (!isMenuOpen) {
              <img src="assets/svg/arrow_drop_down.svg" alt="down svg">
            } @else {
              <img src="assets/svg/arrow_drop_up.svg" alt="up svg">
            }
          </button>
          <mat-menu #menu="matMenu">
            @for (team of teams; track team) {
              <button mat-menu-item (click)="selectTeam(team)" [ngClass]="{ 'selected': selectedTeam?.id == team.id }">
                {{ (team.name == SharedConstants.MY_TEAM && team.id != currentTeam.id) ? SharedConstants.TEAM + ' ' + team.id : team.name }}
                @if (team.id == currentTeam.id) {
                  <span>({{ 'my_team.owner' | translate }})</span>
                }</button>
            }
          </mat-menu>
        }
      </div>
  }

</ng-template>
